export const navigation = [
  {
    title: 'Общественная безопасность',
    link: '/safety',
    icon: './images/nav_icons/1',
  },
  {
    title: 'Обращения граждан',
    link: '/social',
    icon: './images/nav_icons/10',
  },
  {
    title: 'Экономика',
    link: '/economic',
    icon: './images/nav_icons/11',
  },
  {
    title: 'Экология',
    link: '/ecology',
    icon: './images/nav_icons/3',
  },
];
